import React from 'react';

interface SearchStatusAnnouncerProps {
  searchIsLoading: boolean;
  isLoadingAdditionalResults?: boolean;
  numberOfResults?: number;
  searchTerm?: string;
}

function statusText({
  searchIsLoading,
  isLoadingAdditionalResults,
  numberOfResults,
  searchTerm,
}: SearchStatusAnnouncerProps): string {
  if (searchIsLoading && !isLoadingAdditionalResults) {
    return 'Searching…';
  }

  if (typeof numberOfResults !== 'number') {
    return '';
  }

  const suffix = searchTerm ? ` for ${searchTerm}` : '';

  if (numberOfResults === 0) {
    return `No results found${suffix}`;
  }

  const resultString = numberOfResults === 1 ? 'result' : 'results';
  return `${numberOfResults.toLocaleString(
    'en-US'
  )} ${resultString} found${suffix}`;
}

/**
 * Announces the search lifecycle to screen readers. Must stay mounted across
 * the whole lifecycle: a live region that is unmounted while loading and
 * remounted with its text already in place announces nothing, which is how
 * both the result count and the no-results message were silent.
 */
const SearchStatusAnnouncer = (props: SearchStatusAnnouncerProps) => (
  <div className="sr-only" role="status">
    {statusText(props)}
  </div>
);

export default SearchStatusAnnouncer;
